export default __webpack_public_path__ + "static/data-quality-v2-cc6934229235af0b8f6672a32b02f8b0.svg";